import { React, useState, useEffect } from "react";
import axios from "axios";
import PropTypes from "prop-types";
import {
  Multiselect,
  EnhancedAutocomplete,
  CreateValidateTextField,
  LocationAutocomplete,
} from "..";
import {
  Dialog,
  DialogTitle,
  FilledInput,
  Snackbar,
  Alert,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";

function EventEdit(props) {
  const {
    userType,
    username,
    updateTable,
    setUpdateTable,
    currEvent,
    // currMinMembLvl,
    // currMaxContacts,
    setEventOffset,
    membershipLvls,
  } = props;

  // Event fields
  const [eventTitle, setEventTitle] = useState(currEvent.event);
  const [description, setDescription] = useState(currEvent.description);
  const [startDate, setStartDate] = useState(currEvent.startDate);
  const [endDate, setEndDate] = useState(currEvent.endDate);

  const [minMembLvl, setMinMembLvl] = useState("");
  const [maxContacts, setMaxContacts] = useState([]);
  const [allowedMembLvls, setAllowedMembLvls] = useState([]);

  const [beginRegistrationDate, setBeginRegsitrationDate] = useState(
    currEvent.beginRegistrationDate
  );
  const [endRegistrationDate, setEndRegistrationDate] = useState(
    currEvent.endRegistrationDate
  );
  const [expireDate, setExpireDate] = useState(currEvent.expireDate);

  // Current Dates
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const currentDay = currentDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedCurrentDate = `${currentYear}-${currentMonth}-${currentDay}`;

  const nextDate = new Date();
  nextDate.setDate(currentDate.getDate() + 1);
  const nextYear = nextDate.getFullYear();
  const nextMonth = (nextDate.getMonth() + 1).toString().padStart(2, "0"); // add 1 to month because getMonth() returns 0-based index, and pad with leading zero if necessary
  const nextDay = nextDate.getDate().toString().padStart(2, "0"); // pad with leading zero if necessary
  const formattedNextDate = `${nextYear}-${nextMonth}-${nextDay}`;

  //dialog and snackbar
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const maxTitleLength = 100;
  const maxDescLength = 30000;

  useEffect(() => {
    setEventTitle(currEvent.event);
    setDescription(currEvent.description);
    setStartDate(currEvent.startDate);
    setEndDate(currEvent.endDate);
    setBeginRegsitrationDate(currEvent.beginRegistrationDate);
    setEndRegistrationDate(currEvent.endRegistrationDate);
    setExpireDate(currEvent.expireDate);
  }, [currEvent, openEditDialog]);

  useEffect(() => {
    const body = new FormData();
    if (currEvent == null) {
      return;
    }
    body.append("eventId", currEvent.eventId);
    axios.post("/events/getEventMaxes", body).then((res) => {
      const data = res.data;
      if (data.success) {
        setMinMembLvl(data.minMembLvl);
        setMaxContacts(data.eventMaxes);
      }
    });
  }, [currEvent]);

  useEffect(() => {
    if (minMembLvl != "" && minMembLvl != null) {
      setAllowedMembLvls(
        membershipLvls.slice(membershipLvls.indexOf(minMembLvl.toString()))
      );
    } else {
      setAllowedMembLvls([]);
    }
  }, [minMembLvl]);

  useEffect(() => {
    const tempArray = [];
    for (let i = 0; i < membershipLvls.length; i++) {
      if (
        i < membershipLvls.indexOf(minMembLvl.toString()) ||
        membershipLvls.indexOf(minMembLvl.toString()) == -1
      ) {
        tempArray[i] = "0";
      } else {
        tempArray[i] = maxContacts[i];
      }
    }
    setMaxContacts(tempArray);
  }, [minMembLvl]);

  const handleEditEvent = (e, draft) => {
    e.preventDefault();

    //Ensure at least one maxContacts is greater than 0
    if(!maxContacts.some((mc) => mc > 0)) {
      alert("Cannot set maximum number of contacts to 0 for all partnership levels.");
      return;
    }

    const body = new FormData();
    body.append("eventId", currEvent.eventId);
    body.append("event", eventTitle);
    body.append("description", description);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("beginRegistrationDate", beginRegistrationDate);
    body.append("endRegistrationDate", endRegistrationDate);
    body.append("expireDate", endDate);
    body.append("maxContacts", maxContacts);
    body.append(
      "minMembershipLevelIndex",
      membershipLvls.indexOf(minMembLvl.toString())
    );

    axios.post("/events/updateEvent", body).then((res) => {
      const data = res.data;
      if (data.success) {
        resetHooks();
        setOpenEditDialog(false);
        setUpdateTable(!updateTable);
      } else {
        setSnackbarMessage(data.message);
        setSnackbarOpen(true);
      }
    });
  };

  const handleMaxContacts = (event, index) => {
    const tempArray = maxContacts.slice();
    tempArray[index] = event;
    setMaxContacts(tempArray);
  };

  const resetHooks = () => {
    setEventTitle("");
    setDescription("");
    setStartDate(formattedCurrentDate);
    setEndDate(formattedNextDate);
    setBeginRegsitrationDate(formattedCurrentDate);
    setEndRegistrationDate(formattedNextDate);
  };

  const maxContactsFields = allowedMembLvls.map((membershipLevel, index) => (
    <div className="MaxContacts" key={index}>
      <div className="EventCreate-maxContacts text-lg font-brand-primary">
        Maximum number of contacts for {membershipLevel} *
      </div>
      <CreateValidateTextField
        pattern="\d+"
        value={
          maxContacts[index + membershipLvls.length - allowedMembLvls.length]
        }
        setter={(event) =>
          handleMaxContacts(event, membershipLvls.indexOf(membershipLevel))
        }
        errorMessage={"Invalid Number of Contacts."}
        required={true}
        maxLength={5}
      />
    </div>
  ));

  function showEditDialog() {
    return (
      <Dialog open={openEditDialog} maxWidth={false}>
        <DialogTitle className="Event-title mx-auto text-2xl font-bold font-brand-primary">
          Edit Event
        </DialogTitle>
        <div className="EventEdit-modalContainer flex w-fit mb-4 mx-4">
          <div className="EventEdit-modalLeftContainer flex flex-col w-fit">
            <div className="EventEdit-titleContainer flex flex-col w-96 mx-4 mb-2">
              <div className="EventEdit-title text-lg font-brand-primary">
                Event Title * {maxTitleLength - eventTitle.length} characters
                left
              </div>
              <CreateValidateTextField
                placeholder="Event Title"
                pattern="(?=.*\w).+"
                value={eventTitle}
                setter={setEventTitle}
                errorMessage={"Invalid Title."}
                required={true}
                maxLength={maxTitleLength}
              />
            </div>
            <div className="EventEdit-maxContactsContainer flex flex-col w-96 mx-4 mb-2">
              {maxContactsFields}
            </div>
            <div className="EventEdit-descContainer flex flex-col w-96 mx-4 mb-2">
              <div className="EventEdit-maxContacts text-lg font-brand-primary">
                Description * {maxDescLength - description.length} characters
                left
              </div>
              <textarea
                value={description}
                onChange={(event) => {
                  if (event.target.value.length <= maxDescLength) {
                    setDescription(event.target.value);
                  }
                }}
                className="rounded-xl bg-white p-2 border border-gray-300"
                type="textarea"
                placeholder="Event description"
                required={true}
              />
            </div>
            <div className="EventEdit-dateContainer flex justify-between">
              <div className="EventEdit-startDateContainer flex flex-col w-44 ml-4 mb-2">
                <div className="EventEdit-startDateTitle text-lg font-brand-primary">
                  Event Start Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl bg-white border border-gray-300 h-11 [&>input]:pt-2"
                />
              </div>
              <div className="EventEdit-endDateContainer flex flex-col w-44 mr-4 mb-2">
                <div className="EventEdit-endDateTitle text-lg font-brand-primary">
                  Event End Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl h-11 bg-white border border-gray-300 [&>input]:pt-2"
                />
              </div>
            </div>
          </div>
          <div className="EventEdit-modalRightContainer flex flex-col w-fit">
            <div className="EventEdit-membershipLvlContainer flex flex-col w-96 mx-4">
              <div className="EventEdit-JobLevelTitle text-lg font-brand-primary">
                Minimum partnership level required to attend: *
              </div>
              <Multiselect
                options={membershipLvls}
                selectedValue={[minMembLvl]}
                selectedSetter={setMinMembLvl}
                multiStatus={false}
              />
            </div>
            <div className="EventEdit-dateContainer flex justify-between">
              <div className="EventEdit-beginRegistrationDateContainer flex flex-col w-44 ml-4 mb-2">
                <div className="EventEdit-beginRegistrationDateTitle text-lg font-brand-primary">
                  Registration Start Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={beginRegistrationDate}
                  onChange={(e) => setBeginRegsitrationDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl bg-white border border-gray-300 h-11 [&>input]:pt-2"
                />
              </div>
              <div className="EventEdit-endRegistrationDateContainer flex flex-col w-44 mr-4 mb-2">
                <div className="EventEdit-endRegistrationDateTitle text-lg font-brand-primary">
                  Registration End Date *
                </div>
                <FilledInput
                  required
                  type="date"
                  value={endRegistrationDate}
                  onChange={(e) => setEndRegistrationDate(e.target.value)}
                  disableUnderline={true}
                  className="rounded-xl h-11 bg-white border border-gray-300 [&>input]:pt-2"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="EventEdit-buttonContainer flex justify-between px-8 mb-4">
          {/* <button
                type="button"
                className="primary-button bg-brand-secondary mb-2 h-11 pt-3"
                onClick={(event) => handleEditEvent(event, true)}
              >
                Save As Draft
              </button> */}
          <button
            type="button"
            className="primary-button bg-brand-quaternary mb-2 h-11 pt-3"
            onClick={(event) => handleEditEvent(event, false)}>
            Edit Event
          </button>
          {/* <button
                type="button"
                className="primary-button bg-brand-primary  mb-2 h-11 pt-3"
                onClick={resetHooks}
              >
                Reset
              </button> */}
          <button
            type="button"
            className="primary-button bg-brand-primary mb-2 h-11 pt-3"
            onClick={() => {
              setOpenEditDialog(false);
              resetHooks();
            }}>
            Cancel
          </button>
        </div>
        <Snackbar
          open={snackbarOpen}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={6000}
          onClose={() => {
            setSnackbarOpen(false);
            setSnackbarMessage("");
          }}>
          <Alert
            onClose={() => {
              setSnackbarOpen(false);
              setSnackbarMessage("");
            }}
            severity="error"
            sx={{ width: "100%" }}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Dialog>
    );
  }

  return (
    <div className="EventEdit-container">
      {showEditDialog()}
      <button type="button" onClick={() => setOpenEditDialog(true)}>
        <EditIcon fontSize="large" className="fill-brand-quaternary" />
      </button>
    </div>
  );
}

EventEdit.propTypes = {
  userType: PropTypes.string.isRequired,
  username: PropTypes.string.isRequired,
  updateTable: PropTypes.bool.isRequired,
  setUpdateTable: PropTypes.func.isRequired,
  currEvent: PropTypes.shape({
    eventId: PropTypes.number,
    event: PropTypes.string,
    description: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    beginRegistrationDate: PropTypes.string,
    endRegistrationDate: PropTypes.string,
    expireDate: PropTypes.string,
  }),
  currMinMembLvl: PropTypes.string,
  currMaxContacts: PropTypes.array,
  setEventOffset: PropTypes.func,
  membershipLvls: PropTypes.array,
};
export default EventEdit;
